import { render } from "./Approve.vue?vue&type=template&id=05d306b3"
import script from "./Approve.vue?vue&type=script&lang=ts"
export * from "./Approve.vue?vue&type=script&lang=ts"
script.render = render

export default script